export default __webpack_public_path__ + "static/media/FP_GM_F.0bdc6f1b.png";